import React, {
	memo,
	useCallback,
	useMemo,
	useState
} from 'react';

import Alert from '../components/Alert';

const useDeleteConfirm = onDelete => {
	const [ deleteConfirm, setDeleteConfirm ] = useState( false );
	const [ toDelete, setToDelete ] = useState( {} );

	const handleDelete = useCallback( async () => {
		await onDelete( toDelete );
	}, [
		onDelete,
		toDelete
	] );

	const deleteConfirmCloseModal = useCallback( () => setDeleteConfirm( false ), [] );

	const DeleteConfirmAlert = useMemo( () => memo( function DeleteConfirmAlert() {
		return ( <Alert
			action={ handleDelete }
			name="delete-confirm-alert"
			message={ deleteConfirm }
			open={ Boolean( deleteConfirm ) }
			closeModal={ deleteConfirmCloseModal }
			type="delete"
		/> );
	} ), [ deleteConfirm, deleteConfirmCloseModal, handleDelete ] );

	return {
		DeleteConfirmAlert,
		setDeleteConfirm,
		setToDelete
	};
};

export default useDeleteConfirm;
